module.exports = __webpack_public_path__ + "static/media/slider_img1.52fd2fad.jpg";